<template>
  <div :class="toggle ? 'pkd-root' : ''">
    <w-switch
      v-if="toggle"
      :model="toggle"
      :on="areManyItems ? 'Nazwy' : 'Nazwa'"
      :off="areManyItems ? 'Symbole' : 'Symbol'"
      class="toggle"
    ></w-switch>
    <w-vue-select
      :model="model"
      :values="showedOptions"
      :searchable="true"
      @input="fixLabels"
      :class="toggle ? 'pkd-list' : ''"
      placeholder="Numery PKD..."
    >
      <span name="no-options">Przepraszamy, nie znaleziono podanego numeru PKD.</span>
    </w-vue-select>
    <small>{{this.count}} pierwszych pozycji</small>
  </div>
</template>

<script>
import axios from 'axios';

import WVueSelect from './vue-select.vue';
import modelMixin from '../mixins/modelMixin';

export default {
  name: 'pkd-select',
  components: {WVueSelect},
  mixins: [modelMixin],
  data() {
    return {
      options: [],
      showedOptions: []
    };
  },
  props: {
    url: {
      type: String,
      default: 'https://pkd.api.witkac.pl'
    },
    count: {
      type: Number,
      default: 100
    },
    toggle: {
      type: Object
    }
  },
  computed: {
    modelIsAnArray() {
      return this.model.$schema.type === 'array';
    },
    areManyItems() {
      return this.modelIsAnArray && this.model.$items.length > 1;
    }
  },
  methods: {
    getOptions() {
      axios
        .get(`${this.url}/?count=${this.count}`)
        .then(res => {
          this.options = res.data.list.map(item => ({value: item.symbol, text: item.nazwa}));
        })
        .catch(error => this.$emit('error', 'Nie udało się pobrać listy PKD'));
    },
    getShowedOptions() {
      if (this.toggle && this.toggle.$model) this.showedOptions = this.options;
      else this.showedOptions = this.options.map(item => ({value: item.value, text: item.value}));
    },
    fixLabels(val) {
      if (this.toggle && !this.toggle.$model)
        if (this.modelIsAnArray) {
          for (let i = 0; i < val.length; i++) {
            let item = this.options.find(x => x.value == val[i].value);
            this.model.$value[i].text = item.text;
          }
        } else if (this.model.$schema.type == 'object') {
          let text = this.options.find(x => x.value == val.value).text;
          this.$set(this.model.$value, 'text', text);
        }
    }
  },
  watch: {
    options: {
      handler() {
        return this.getShowedOptions();
      },
      immediate: true
    },
    'toggle.$value': {
      handler() {
        return this.getShowedOptions();
      }
    }
  },
  beforeMount() {
    this.getOptions();
  }
};
</script>
<style>
.pkd-root {
  position: relative;
}
.toggle {
  position: absolute !important;
  left: 75px;
  top: 1px;
  height: 0px;
  z-index: 1;
}
.toggle > i {
  height: 18px !important;
}
.pkd-list .vs__selected-options {
  margin-left: 75px;
}
</style>
